"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityWrapper = EntityWrapper;
var jsx_runtime_1 = require("react/jsx-runtime");
var EntityProvider_1 = __importDefault(require("./EntityProvider"));
var EntityCrud_1 = require("./EntityCrud");
function EntityWrapper(props) {
    return ((0, jsx_runtime_1.jsx)(EntityProvider_1.default, { children: (0, jsx_runtime_1.jsx)(EntityCrud_1.EntityCrud, __assign({}, props)) }));
}
